import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { Section } from '../../Tool-kit/Section'
import Text from '../../Tool-kit/Typography'
import Logo from '../../assests/images/Logo.png'
import ContactForm from '../Contact-form'
import Flex from '../../Tool-kit/Flex'
import { devices } from '../../Tool-kit/styles/mediaQueries'
import InstagramIcon from 'assests/icons/Instagram'
import LinkedInIcon from 'assests/icons/Linkedin'
import TwitterIcon from 'assests/icons/Twitter'
import { useTranslation } from 'react-i18next'
import { useMediaQuery } from '@mui/material'
import MailchimpSubscribe from 'react-mailchimp-subscribe'
const {
  REACT_APP_MAILCHIMP_API,
  REACT_APP_MAILCHIMP_U,
  REACT_APP_MAILCHIMP_NEWSLETTER_ID
} = process.env
const url = `${REACT_APP_MAILCHIMP_API}?u=${REACT_APP_MAILCHIMP_U}&id=${REACT_APP_MAILCHIMP_NEWSLETTER_ID}`

const Wrapper = styled('footer')`
  background: #000000;
  padding-top: 8rem;
  margin-top: auto;
`

const CopyRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 0.793546px solid #f0f0f0;
  padding: 2rem 0rem;
  margin-top: 3rem;
  font-size: 1.4rem;
  line-height: 20px;
  text-align: center;
  font-weight: 500;
  color: white;
`

const Content = styled(Flex)`
  gap: 5.7rem;
  justify-content: space-between;
  width: 90%;
  margin: auto;
  .logo {
    height: 3.4rem;
    width: 16.3rem;
  }
  @media ${devices.tabland} {
    width: 90%;
  }
  @media ${devices.tabport} {
    flex-wrap: wrap;
    width: 95%;
  }
  @media ${devices.phone} {
    flex-direction: column;
    margin: 0px;
    width: 100%;
  }
`
const Footer = () => {
  const isMobile = useMediaQuery(devices.phone)
  const { t } = useTranslation()
  const footerLinks = [
    {
      label: t('c.domains'),
      path: '/'
    },
    {
      label: t('c.account'),
      path: '/account'
    },
    {
      label: t('c.learn'),
      path: '/learn'
    },
    {
      label: t('c.faq'),
      path: '/faq'
    },
    {
      label: t('c.affliate'),
      path: '/affliate'
    },
    {
      label: t('c.contact'),
      path: '/contact'
    }
  ]
  return (
    <Wrapper>
      <Section>
        <Content gap="" alignItems="flexStart">
          <img src={Logo} alt="logo" className="logo" />
          <div>
            <Text font="caption" color="white" fontSize="2.2rem" mb="1rem">
              {t('c.followus')}
            </Text>
            <Flex gap=".9rem" justifyContent="flex-start">
              <a
                href="https://www.linkedin.com/company/web3-domains/"
                target="_blank"
                className="socienicon"
              >
                <LinkedInIcon />
              </a>
              <a
                href="https://twitter.com/theweb3domains"
                target="_blank"
                className="socienicon"
              >
                <TwitterIcon />
              </a>
              <a
                href="https://instagram.com/theweb3domains"
                target="_blank"
                className="socienicon"
              >
                <InstagramIcon />
              </a>
            </Flex>
          </div>
          <div>
            <Text font="caption" color="white" fontSize="2.2rem" mb="1rem">
              {t('c.links')}
            </Text>
            {footerLinks.map((item, id) => (
              <Link key={id} to={item.path}>
                <Text
                  font="caption"
                  color="white"
                  fontSize="1.2rem"
                  lineHeight="198.2%"
                  letterSpacing="0.01em"
                  key={item.label}
                >
                  {item.label}
                </Text>
              </Link>
            ))}
          </div>
          <div>
            <Text font="caption" color="white" fontSize="2.2rem" mb="1rem">
              {t('c.contact')}
            </Text>
            {/* <a href="https://w3d.bnb" target="_blank"> */}
            <Text
              font="caption"
              color="white"
              fontSize="1.2rem"
              lineHeight="198.2%"
              letterSpacing="0.01em"
            >
              W3D.BNB
            </Text>
            {/* </a> */}
          </div>
          <MailchimpSubscribe
            url={url}
            render={({ subscribe, status, message }) => (
              <ContactForm
                status={status}
                message={message}
                onValidated={subscribe}
              />
            )}
          />
        </Content>
        <CopyRight>
          <Flex
            gap="2rem"
            alignItems={isMobile ? 'center' : 'flex-start'}
            justifyContent="space-between"
            direction={isMobile ? 'column' : 'row'}
          >
            <Flex gap="1rem" direction={isMobile ? 'column' : 'row'}>
              <Link
                to="/privacy-and-policy"
                style={{
                  color: 'inherit'
                }}
              >
                Privacy & Policy{' '}
              </Link>
              <Link
                to="/terms-of-use"
                style={{
                  color: 'inherit'
                }}
              >
                Terms of Use
              </Link>
              <a
                href="https://strapi.testnet.5ire.network/uploads/BNBSERVICEGUIDE_b5f17c87e6.pdf"
                target="_blank"
                style={{
                  color: 'inherit'
                }}
              >
                Service Guide
              </a>
              <a
                href="https://strapi.testnet.5ire.network/uploads/Real_Domain_8522abefde.pdf"
                target="_blank"
                style={{
                  color: 'inherit'
                }}
              >
                Whitepaper
              </a>
            </Flex>
            © 2022 .BNB DOMAINS. All rights reserved.
          </Flex>
        </CopyRight>
      </Section>
    </Wrapper>
  )
}

export default Footer
